export const onrampManifest = {
    version: 1,
    platform_gates: {
        web: 'web_onramp_enabled',
        mobile: 'mobile_onramp_enabled',
    },
    settings: {
        settlement: {
            asset: 'USDC',
            network: 'solana',
            provider_asset_code: 'USDC_SOL',
            decimals: 6,
        },
        fees: {
            principal_excludes_fees: true,
            sponsorship_enabled: false,
        },
        updates: {
            poll_seconds: 7,
        },
        guest_checkout: {
            enabled: true,
            countries: ['US'],
            excluded_subdivisions: ['US-NY', 'US-WA'],
            methods: ['apple_pay', 'google_pay'],
        },
    },
    onramp: {
        host_routes: {
            manual_transfer: {
                enabled: true,
                surfaces: ['web', 'ios', 'android'],
            },
        },
        providers: {
            moonpay: {
                enabled: true,
                methods: {
                    card: {
                        enabled: true,
                        product: 'platform',
                        provider_method: 'card',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    apple_pay: {
                        enabled: true,
                        product: 'platform',
                        provider_method: 'apple_pay',
                        surfaces: ['web', 'ios'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    google_pay: {
                        enabled: true,
                        product: 'platform',
                        provider_method: 'google_pay',
                        surfaces: ['web', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    cex_connect: {
                        enabled: true,
                        product: 'commerce',
                        provider_method: 'coinbase',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    crypto_deposit: {
                        enabled: true,
                        product: 'commerce',
                        provider_method: 'deposits',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    wallet_connect: {
                        enabled: true,
                        product: 'commerce',
                        provider_method: 'connect_wallet',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    paypal: {
                        enabled: true,
                        product: 'platform',
                        provider_method: 'paypal',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    venmo: {
                        enabled: true,
                        product: 'platform',
                        provider_method: 'venmo',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    revolut_pay: {
                        enabled: true,
                        product: 'platform',
                        provider_method: 'revolut_pay',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    moonpay_balance: {
                        enabled: true,
                        product: 'platform',
                        provider_method: 'moonpay_balance',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    bank_transfer: {
                        sepa: {
                            enabled: true,
                            product: 'platform',
                            provider_method: 'sepa',
                            execution: 'platform_sepa',
                            surfaces: ['web', 'ios', 'android'],
                            geography: {
                                countries: ['*'],
                                subdivisions: ['*'],
                                excluded_countries: [],
                                excluded_subdivisions: [],
                            },
                        },
                        gbp_bank_transfer: {
                            enabled: true,
                            product: 'widget',
                            provider_method: 'fps',
                            execution: 'hosted_checkout',
                            surfaces: ['web', 'ios', 'android'],
                            geography: {
                                countries: ['GB'],
                                subdivisions: ['*'],
                                excluded_countries: [],
                                excluded_subdivisions: [],
                            },
                        },
                        gbp_open_banking_payment: {
                            enabled: true,
                            product: 'widget',
                            provider_method: 'fps_open_banking',
                            execution: 'hosted_checkout',
                            surfaces: ['web', 'ios', 'android'],
                            geography: {
                                countries: ['GB'],
                                subdivisions: ['*'],
                                excluded_countries: [],
                                excluded_subdivisions: [],
                            },
                        },
                        pix_instant_payment: {
                            enabled: true,
                            product: 'widget',
                            provider_method: 'pix',
                            execution: 'hosted_checkout',
                            surfaces: ['web', 'ios', 'android'],
                            geography: {
                                countries: ['BR'],
                                subdivisions: ['*'],
                                excluded_countries: [],
                                excluded_subdivisions: [],
                            },
                        },
                    },
                },
            },
        },
    },
    offramp: {
        providers: {
            moonpay: {
                enabled: true,
                methods: {
                    ach_bank_transfer: {
                        enabled: true,
                        product: 'widget',
                        provider_method: 'ach_bank_transfer',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    sepa_bank_transfer: {
                        enabled: true,
                        product: 'widget',
                        provider_method: 'sepa_bank_transfer',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    gbp_bank_transfer: {
                        enabled: true,
                        product: 'widget',
                        provider_method: 'gbp_bank_transfer',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    gbp_open_banking_payment: {
                        enabled: true,
                        product: 'widget',
                        provider_method: 'gbp_open_banking_payment',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    credit_debit_card: {
                        enabled: true,
                        product: 'widget',
                        provider_method: 'credit_debit_card',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    paypal: {
                        enabled: true,
                        product: 'widget',
                        provider_method: 'paypal',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    venmo: {
                        enabled: true,
                        product: 'widget',
                        provider_method: 'venmo',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    moonpay_balance: {
                        enabled: true,
                        product: 'widget',
                        provider_method: 'moonpay_balance',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                    cash_app: {
                        enabled: true,
                        product: 'widget',
                        provider_method: 'cash_app',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['*'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: [],
                        },
                    },
                },
            },
        },
    },
    host_routes: {
        manual_withdraw: {
            enabled: true,
            asset: 'USDC',
            network: 'solana',
            surfaces: ['web', 'ios', 'android'],
        },
    },
    native_apps: [],
    direct_token_purchase: {
        feature_gate: 'direct_token_purchase_enabled',
        settings: {
            buy_action_threshold_usdc_d6: '25000000',
        },
        providers: {
            moonpay: {
                enabled: true,
                methods: {
                    apple_pay: {
                        enabled: true,
                        product: 'platform',
                        provider_method: 'apple_pay',
                        surfaces: ['web', 'ios'],
                        geography: {
                            countries: ['US'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: ['US-NY', 'US-WA'],
                        },
                    },
                    google_pay: {
                        enabled: true,
                        product: 'platform',
                        provider_method: 'google_pay',
                        surfaces: ['web', 'android'],
                        geography: {
                            countries: ['US'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: ['US-NY', 'US-WA'],
                        },
                    },
                    card: {
                        enabled: true,
                        product: 'platform',
                        provider_method: 'card',
                        surfaces: ['web', 'ios', 'android'],
                        geography: {
                            countries: ['US'],
                            subdivisions: ['*'],
                            excluded_countries: [],
                            excluded_subdivisions: ['US-NY', 'US-WA'],
                        },
                    },
                },
            },
        },
    },
};
export const onrampManifestHash = '604f509d92b67785aa704d5271d2117d30b309def6d7243ca3052bdeaa783792';
